export const ZOOM_TYPES = {
  ALIGN_MIDDLE: "align-middle",
  FIT: "fit",
  FULL: "full",
};

export const ZOOM_OPTIONS = [
  { value: ZOOM_TYPES.FIT, label: "Zoom to Fit" },
  { value: ZOOM_TYPES.FULL, label: "Zoom to 100%" },
];

export const ZOOM_MODES = {
  IN: "in",
  OUT: "out",
};

export const ZOOM_MAX = 2.5;
export const ZOOM_MIN = 0.5;
export const ZOOM_STEP = 0.1;

export function createCenterViewHandler({ chartContainerRef, zoom, setZoom }) {
  return function handleCenterView({ type, minZoomOnCenterView } = {}) {
    if (!chartContainerRef.current) return;

    const scrollContainer = chartContainerRef.current.parentElement;
    const chart = chartContainerRef.current;

    const containerWidth = scrollContainer.offsetWidth;
    const chartWidth = chart.scrollWidth * zoom;

    const centerHorizontally = () => {
      const chartRect = chart.getBoundingClientRect();
      const containerRect = scrollContainer.getBoundingClientRect();
      const chartLeftRelativeToContainer =
        chartRect.left - containerRect.left + scrollContainer.scrollLeft;
      const scrollLeft =
        chartLeftRelativeToContainer + (chartWidth - containerWidth) / 2;
      scrollContainer.scrollLeft = scrollLeft;
    };

    if (type === ZOOM_TYPES.ALIGN_MIDDLE) {
      centerHorizontally();
      scrollContainer.scrollTop = 0;
    }

    if (type === ZOOM_TYPES.FIT) {
      const unscaledChartWidth = chart.offsetWidth;
      const fitZoom = containerWidth / unscaledChartWidth;

      setZoom(Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, fitZoom)));

      requestAnimationFrame(() => {
        centerHorizontally();
        scrollContainer.scrollTop = 0;
      });
    }

    if (type === ZOOM_TYPES.FULL) {
      setZoom(1);

      requestAnimationFrame(() => {
        centerHorizontally();
        scrollContainer.scrollTop = 0;
      });
    }
  };
}
